import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import FundsContext from '../context';
import Loading from '../../../../../shared/loading';
import { RowContainer, Link } from '../../../shared/styles';
import { DataColumn, NameColumn } from './styles';
import { useViewFundToImport } from '../../../../../services/lwadmin/fund/fund-service';

const Name = styled(NameColumn)`
  font-size: 14px;
  line-height: 120%;
`;

const Data = styled(DataColumn)`
  font-size: 14px;
  line-height: 120%;
`;

const ImportLink = styled(Link)`
  &:hover {
    cursor: pointer;
  }
`;

export default function Fund({ fund }) {
  const { dispatch } = React.useContext(FundsContext);
  const [{ data, loading }, view] = useViewFundToImport();
  const loadingRef = React.useRef();

  const handleView = e => {
    e && e.preventDefault();

    view(fund.dpFundDataProviderId);
  };

  React.useEffect(() => {
    const payload = _.get(data, 'fund');
    payload && dispatch({ type: 'setViewFund', payload });
  }, [data, dispatch]);

  React.useEffect(() => (loadingRef.current.toggle(loading)), [loading]);

  return (
    <RowContainer>
      <Name>{fund.dpFundName}</Name>
      <Data>{fund.dpFundDataProviderId}</Data>
      <Data>{fund.dpFundIsin}</Data>
      <Data>{fund.dpFundApir}</Data>
      <Data>{fund.dpFundTicker}</Data>
      <Data>{fund.lwStockCode}</Data>
      <Data>
        <Loading variant="button" ref={loadingRef}>
          {!!fund.dpFundDataProviderId && <ImportLink onClick={handleView}>Import</ImportLink>}
        </Loading>
      </Data>
    </RowContainer>
  );
}

Fund.propTypes = {
  fund: PropTypes.shape({
    dpFundDataProviderId: PropTypes.string,
    dpFundIsin: PropTypes.string,
    dpFundApir: PropTypes.string,
    dpFundName: PropTypes.string.isRequired,
    dpFundTicker: PropTypes.string,
    lwStockCode: PropTypes.string,
  }).isRequired,
};
